<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 content-class="round-2xl")
  v-card
    v-card-title.px-4
      v-spacer
      .text-xl.font-bold.ml-10 {{ $t('delete_segment') }}
      v-spacer
      v-btn(icon @click="showDialog = false")
        v-icon mdi-close
    v-divider.mb-6
    .px-6
      .text-lg.font-medium.mb-4 {{ $t('delete_segment_confirmation') }}
      .text-md.mb-16 {{ $t('click_confirm_to_proceed') }}
    v-divider
    v-card-actions.px-6.py-3
      v-spacer
      v-btn.button-md.neutral500--text(@click="showDialog = false" text) {{ $t('cancel') }}
      v-btn.button-md.white--text(@click="confirm" :loading="isLoading" color="danger500" depressed) {{ $t('confirm') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['open', 'deleted', 'segments'],
  data: () => ({
    isLoading: false
  }),
  computed: {
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    ...mapGetters({
      company: 'getCompany',
    }),
  },
  methods: {
    ...mapActions(['showMessage']),
    confirm () {
      this.isLoading = true
      const ids = this.segments.map(item => item.id).join(',')
      this.$axios.delete(`/connect/${this.company.slug}/groups/${ids}`)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.segment_remove_successfully')])
          this.showDialog = false
          this.$emit('deleted')
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_remove_segment')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>